import { TriangleAlert } from "lucide-react";
import { Badge } from "@/components/shadcn/badge";
import { NoxusTooltip } from "@/components/UI/NoxusTooltip";

const COPY = {
  flow: {
    label: "Deleted",
    reason:
      "This flow was deleted and is not being used by the agent. Open it to restore it.",
  },
  "knowledge base": {
    label: "Deleted",
    reason:
      "This knowledge base was deleted and is not being used by the agent.",
  },
  agent: {
    label: "Deleted",
    reason:
      "This agent was deleted and is not being used by this agent. Open it to restore it.",
  },
  table: {
    label: "Deleted",
    reason: "This table was deleted and is not being used by the agent.",
  },
  database: {
    label: "Disconnected",
    reason:
      "This database was disconnected or removed and is not being used by the agent.",
  },
  action: {
    label: "Deleted",
    reason: "This action's node is gone and is not being used by the agent.",
  },
  mcp: {
    label: "Disconnected",
    reason: "This MCP server was disconnected or removed and will not be used.",
  },
} as const;

export type UnavailableResourceKind = keyof typeof COPY;

export function UnavailableResourceBadge({
  kind,
}: {
  kind: UnavailableResourceKind;
}) {
  const { label, reason } = COPY[kind];
  return (
    <NoxusTooltip content={reason} placement="top" asChild>
      <Badge variant="warning" className="gap-1 shrink-0">
        <TriangleAlert />
        {label}
      </Badge>
    </NoxusTooltip>
  );
}
